/**
 * Integrations planned for the next update. The apps show them as "Coming soon", and the server
 * has a provider slot for each (apps/server/src/services/providers/). The plan and the contracts
 * are in docs/upcoming-integrations.md. When one ships, set `available: true` here.
 */
export const UPCOMING_INTEGRATIONS = Object.freeze([
  {
    key: 'sms',
    name: 'SMS',
    summary: 'Bill links, order-ready alerts and campaigns by SMS through a DLT-registered Indian SMS provider.',
    today: 'Free today: WhatsApp click-to-chat links and email.',
    feature: 'sms',
    available: false,
  },
  {
    key: 'whatsappCloud',
    name: 'WhatsApp Business (Cloud API)',
    summary: "E-receipts, order-ready alerts and campaigns sent automatically from your business's WhatsApp number.",
    today: 'Free today: WhatsApp click-to-chat links, sent one by one from your phone.',
    feature: 'whatsappApi',
    available: false,
  },
  {
    key: 'paymentGateway',
    name: 'Payment gateway',
    summary: 'Dynamic UPI QR, cards and wallets confirmed automatically, at the counter and on the self-order kiosk.',
    today: 'Today: your UPI QR on screen, and the cashier confirms the payment.',
    feature: 'paymentGateway',
    available: false,
  },
]);

export const UPCOMING_BY_KEY = Object.freeze(Object.fromEntries(UPCOMING_INTEGRATIONS.map((u) => [u.key, u])));
